import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18403ab7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex justify-center" }
const _hoisted_2 = {
  class: "container",
  style: {"max-width":"80rem"}
}
const _hoisted_3 = { class: "bg-white" }
const _hoisted_4 = { class: "pl-1 pr-1" }
const _hoisted_5 = { class: "text-3xl font-bold text-green-500" }
const _hoisted_6 = { class: "text-green-500" }
const _hoisted_7 = { class: "flex justify-between items-center -gap-x-2" }
const _hoisted_8 = { class: "font-bold" }

import { ref, reactive, computed, onBeforeMount } from 'vue';
import { useMeta } from 'quasar';
import { treeToList } from 'src/utils/tree';
import { create } from 'src/api/Message';
import {
  isValid,
  sendSmsSecurityCode,
  vertifySmsSecurityCode,
} from 'src/utils/sms';
import { PageDto } from 'src/api/types';
import { Notify } from 'quasar';
import { useMetaStore } from 'stores/modules/meta';
import { useI18n } from 'vue-i18n';
import { PageWithRegionsDto } from 'src/api/types';
import { find } from 'src/api/Page';
import { filterIsActive } from 'src/utils/fetch';


import { PageWithChildrenDto, usePageStore } from 'stores/modules/page';

const __default__ = {
  async preFetch({ store, currentRoute }) {
    const pageStore = usePageStore(store);
    await pageStore.fetch({ url: currentRoute.path });
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ContactPopupPage',
  setup(__props) {

const { t } = useI18n();
const pageStore = usePageStore();

const page = ref({} as PageWithRegionsDto);

const model = reactive({
  name: '',
  company: '',
  job: '',
  phone: '',
  about: '',
  securityCode: '',
  content: '',
});

onBeforeMount(async () => {
  const { data } = await find('/about/contact');
  filterIsActive(data);
  page.value = data;

  const id = page.value?.regions?.[0]?.extraProperties?.linkPageId;
  if (id) {
    const root = treeToList(pageStore.menus, { pid: 'parentId' }).filter(
      (t: PageWithChildrenDto) => t.id === id
    )[0];
    model.about = root.children?.[0]?.id;
  }
});

const metaStore = useMetaStore();
useMeta(
  Object.assign({}, metaStore.meta, {
    title: page.value.title,
    titleTemplate: (title: string) => `${title} - ${metaStore.meta.title}`,
  })
);

// const settings = metaStore.settings;

const formRef = ref();

const state = reactive({
  loading: false,
  vertifying: t('Contact.form.vertifying'),
});

const productOptions = computed(() => {
  const id = page.value?.regions?.[0]?.extraProperties?.linkPageId;
  if (id) {
    const root = treeToList(pageStore.menus, { pid: 'parentId' }).filter(
      (t: PageWithChildrenDto) => t.id === id
    )[0];

    const options =
      root?.children?.map((x: PageDto) => ({
        label: x.title + t('Contact.form.product'),
        value: x.id,
      })) ?? [];

    return options;
  }
  return [];
});

let timeout: NodeJS.Timeout;

const clearVertifyingTimeout = () => {
  state.vertifying = t('Contact.form.vertifying');
  clearInterval(timeout);
};

const setVertifyingTimeout = () => {
  clearInterval(timeout);
  state.vertifying = `${t('Contact.form.vertifying')}(60s)`;
  let seconds = 59;
  timeout = setInterval(() => {
    state.vertifying = `${t('Contact.form.vertifying')}(${seconds}s)`;
    seconds--;
    if (seconds < 0) {
      clearVertifyingTimeout();
    }
  }, 1000);
};

const handleSendSecurityCode = async () => {
  if (state.vertifying !== t('Contact.form.vertifying')) return;
  if (!isValid(model.phone)) {
    Notify.create({
      message: t('Contact.form.phone.lable'),
      type: 'warning',
    });
    return;
  }
  setVertifyingTimeout();

  await sendSmsSecurityCode(model.phone);
  model.securityCode = '';
};

const handleSubmit = async () => {
  state.loading = true;
  try {
    await vertifySmsSecurityCode(model.phone, model.securityCode);
    await create({
      ...model,
    });
    formRef.value?.reset();
    Notify.create(t('Contact.form.notify'));
    clearVertifyingTimeout();
  } finally {
    state.loading = false;
  }
};

const handleReset = () => {
  model.name = '';
  model.company = '';
  model.job = '';
  model.phone = '';
  model.about = '';
  model.securityCode = '';
};

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "flex justify-center" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('Contact.title')), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Contact.message')), 1),
              _createVNode(_component_q_form, {
                ref_key: "formRef",
                ref: formRef,
                class: "py-8 q-gutter-sm",
                onSubmit: handleSubmit,
                onReset: handleReset
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_input, {
                    modelValue: model.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.name) = $event)),
                    label: _ctx.$t('Contact.form.name'),
                    rules: [(val) => val && val.length > 0],
                    outlined: ""
                  }, null, 8, ["modelValue", "label", "rules"]),
                  _createVNode(_component_q_input, {
                    modelValue: model.company,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.company) = $event)),
                    label: _ctx.$t('Contact.form.company'),
                    rules: [(val) => val && val.length > 0],
                    outlined: ""
                  }, null, 8, ["modelValue", "label", "rules"]),
                  _createVNode(_component_q_input, {
                    modelValue: model.job,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.job) = $event)),
                    label: _ctx.$t('Contact.form.job'),
                    rules: [(val) => val && val.length > 0],
                    outlined: ""
                  }, null, 8, ["modelValue", "label", "rules"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_q_input, {
                      class: "flex-1",
                      modelValue: model.phone,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.phone) = $event)),
                      type: "tel",
                      label: _ctx.$t('Contact.form.phone.label'),
                      rules: [
                    (val) =>
                      (val &&
                        val.length > 0 &&
                        /^1[3456789]\d{9}$/.test(val)) ||
                      _ctx.$t('Contact.form.phone.rules'),
                  ],
                      outlined: ""
                    }, null, 8, ["modelValue", "label", "rules"]),
                    _createVNode(_component_q_input, {
                      class: "flex-none w-32",
                      modelValue: model.securityCode,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model.securityCode) = $event)),
                      label: _ctx.$t('Contact.form.securityCode.label'),
                      rules: [
                    (val) =>
                      (val && val.length > 0 && /^\d{4}$/.test(val)) ||
                      _ctx.$t('Contact.form.securityCode.rules'),
                  ],
                      outlined: ""
                    }, null, 8, ["modelValue", "label", "rules"]),
                    _createVNode(_component_q_btn, {
                      class: "mb-6 h-9 flex-none text-green-500 text-base",
                      padding: "8px",
                      flat: "",
                      disable: state.vertifying !== _ctx.$t('Contact.form.vertifying'),
                      onClick: handleSendSecurityCode
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(state.vertifying), 1)
                      ]),
                      _: 1
                    }, 8, ["disable"])
                  ]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('Contact.form.about')), 1),
                  _createVNode(_component_q_btn_toggle, {
                    modelValue: model.about,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((model.about) = $event)),
                    options: productOptions.value,
                    "text-color": "grey-10",
                    color: "blue-grey-1",
                    "toggle-color": "green-2",
                    "toggle-text-color": "green-6",
                    class: "overflow-hidden text-overflow-ellipsis",
                    flat: ""
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode(_component_q_btn, {
                    class: "w-full mt-4 text-base text-white horizontal-gradient",
                    type: "submit",
                    flat: "",
                    loading: state.loading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Contact.form.submit')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }, 512)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})